<template lang="pug">
    div(
        class="ib-wait-spin"
    )
        div(
            class="spin-wrapper bg"
        )
            div(
                class="spin-content"
            )
        p(v-show="label", class="fg70") {{ label }}
</template>

<script>
    /**
     * DEPRECATED. Use `ib-progress-circular`.
     */
    export default {
        name: 'ib-wait-spin',
        props: {
            /**
            * Toggles a text label with this content
            */
            label: {
                type: String,
                default: null
            }
        }
    }
</script>

<style lang="less" scoped>
    @import "../../less/globals.less";

    .ib-wait-spin {
        display: inline-block;
        text-align: center;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background: fade(@bg, 80%);

        .spin-wrapper {
            content: '';
            color: @fg-select;
            overflow: hidden;
            justify-content: center;
            .spin-content {
                -webkit-animation: spin 0.7s infinite cubic-bezier(0.2,0.6,0.8,0.6);
                animation: spin 0.7s infinite cubic-bezier(0.2,0.6,0.8,0.6);
                border-width: 6px;
                border-style: solid;
                border-color: @bg-accent @bg-gray @bg-gray @bg-accent;
                will-change: transform;
            }
            .spin-content,
            .spin-content:after{
                border-radius: 50%;
                width: 53px;
                height: 53px;
            }
        }
        @-webkit-keyframes spin {
            0% {
                transform: rotate(0deg);
                -webkit-transform: rotate(0deg);
            }
            100% {
                transform: rotate(360deg);
                -webkit-transform: rotate(360deg);
            }
        }
        @keyframes spin {
            0% {
                transform: rotate(0deg);
            }
            100% {
                transform: rotate(360deg);
            }
        }
    }
</style>

<docs>
    Basic Example:
    ```jsx
    <ib-context>
        <div style="display: block">
            <ib-wait-spin style="position: static" />
        </div>
        <hr/>
        <div style="display: block">
            <ib-wait-spin style="position: static" label="Here's a text example"/>
        </div>
    </ib-context>
    ```
</docs>
